import React, { Component, useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import update from 'immutability-helper';
//dev component
import Textfield from '../../../components/CentionTextfield';
import TableComponent from '../../../components/TableComponent';
import ColorPicker from '../../../reactcomponents/ColorPicker';
import DropDown from '../../../components/DropDown';
import adminHelper from '../../../components/adminHelper';
//FLUX actions and store
import AdminAction from '../../../flux/actions/adminActions';
import AdminStore from '../../../flux/stores/adminStore';
import { SaveButton, CancelButton } from '../../../reactcomponents/Admin';
import { TableIconicButton, TextInputRow } from '../../../reactcomponents/Form';
import { I, webRoot, pathPrefix } from '../../../common/v5/config';
import SwitchCheckbox from '../../../reactcomponents/SwitchCheckbox';

global.defaultPaginationSize = 13, global.AREAROUTING = 9, global.AREAREPLACEMENT = 10, global.AREAAUTOFORWARD = 11, global.AREASMS = 12,
    global.AREAFORWARDEXTERNAL = 13;

function AreaAutoFwdExtAddr(props) {
    const [selectedId, setSelectedId] = useState(0);
    const [name, setName] = useState("");
    const [fwdTo, setFwdTo] = useState("");
    const [toFwd, setToFwd] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [addrList, setAddrList] = useState(
        AdminStore.getState().areaAutoFwdExtAddrList?.list || []
    );

    useEffect(() => {
        AdminAction.getAreaAutoFwdExtAddr(props.areaId);
        AdminStore.listen(onFluxStoreChange);
        
        return () => {
            AdminStore.unlisten(onFluxStoreChange);
        };
    }, [props.areaId]);

    const onFluxStoreChange = (state) => {
        if (state.areaAutoFwdExtAddrList != null) {
            setAddrList(state.areaAutoFwdExtAddrList.list);
            setName(state.areaAutoFwdExtAddrList.areaName);
            setFwdTo(state.areaAutoFwdExtAddrList.fwdToEmailAddress);
            setToFwd("");
        } else {
            setAddrList([]);
        }
    };

    const handleItemDeleteAction = (action) => {
        $.ajax(action, {
            type: "DELETE"
        }).done(() => {
            AdminAction.getAreaAutoFwdExtAddr(props.areaId);
        });
    };

    const cancelList = () => {
        location.href = window.location.protocol + "//" +
            window.location.hostname + pathPrefix + "admin#organisations";
    };

    const handleToFwdChange = (v) => {
        setToFwd(v);
        $(".with-errors-content").html("");
    };

    const addAreaAutoFwdExtAddr = () => {
        if (toFwd === "") {
            setErrorMsg(I("* You can not leave this field empty."));
            return;
        }
        
        AdminAction.saveAreaAutoFwdExtAddr(props.areaId, {
            fwdTo: fwdTo,
            matchingEmail: toFwd
        })
        .then(() => {
            setToFwd("");
            AdminAction.getAreaAutoFwdExtAddr(props.areaId);
        });
    };

    const changeAreaFwdToAddress = (e) => {
        setFwdTo(e.target.value);
    };

    const handleAreaFwdToBlur = () => {
        AdminAction.saveAreaFwdToAddr(props.areaId, {
            email: fwdTo
        });
    };

    const RemoveButton = {
        action: webRoot + "areas/" + props.areaId + "/automaticforwardextaddress/{id}",
        name: I("Remove"),
        className: "fa fa-remove"
    };
    
    const forwardedField = (
        <Textfield
            id="toFwd"
            value={toFwd}
            name={I("toFwd")}
            onChange={handleToFwdChange}
        />
    );
    
    const removeField = {
        type: "orgEdit"
    };

    const column = [
        { header: I("Email address to be forwarded"), key: "email", subHeaderAction: forwardedField },
        { header: I("Action"), type: "actionCombineLink", data: RemoveButton, subHeaderAction: removeField, orgType: 'edit' }
    ];
    
    return (
        <div className="area-forward-address">
            <TextInputRow
                id="autofwdextaddr"
                name="autofwdextaddr"
                className="admin-text-input"
                label={I("Forward to address:")}
                value={fwdTo}
                onChange={changeAreaFwdToAddress}
                onBlur={handleAreaFwdToBlur}
            />
            <div className="row">
                <TableComponent
                    dataSource={addrList}
                    columns={column}
                    id={'AreaAutoFwdExtAddr'}
                    itemDeleteAction={handleItemDeleteAction}
                    paginate={true}
                    pageSize={defaultPaginationSize}
                    enablePageSizeChange={false}
                    enableSubHeaders={true}
                    organisationV5={true}
                    areaEditV5={true}
                    itemAddAction={addAreaAutoFwdExtAddr}
                />
            </div>
        </div>
    );
}

function AreaExtFwdAddr(props) {
    const [selectedId, setSelectedId] = useState(0);
    const [areaName, setAreaName] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [addrList, setAddrList] = useState(
        AdminStore.getState().areaExtFwdAddrList?.list || []
    );

    useEffect(() => {
        AdminAction.getAreaExtFwdAddr(props.areaId);
        AdminStore.listen(onFluxStoreChange);
        
        return () => {
            AdminStore.unlisten(onFluxStoreChange);
        };
    }, [props.areaId]);

    const onFluxStoreChange = (state) => {
        if (state.areaExtFwdAddrList != null) {
            setAddrList(state.areaExtFwdAddrList.list);
            setAreaName(state.areaExtFwdAddrList.areaName);
            setName("");
            setEmail("");
        } else {
            setAddrList([]);
        }
    };

    const handleItemDeleteAction = (action) => {
        $.ajax(action, {
            type: "DELETE"
        }).done(() => {
            AdminAction.getAreaExtFwdAddr(props.areaId);
        });
    };

    const cancelList = () => {
        location.href = window.location.protocol + "//" +
            window.location.hostname + pathPrefix + "admin#organisations";
    };

    const addAreaExtFwdAddr = () => {
        if (name === "") {
            setErrorMsg(I("* You cannot leave the Name field empty."));
            return;
        }
        if (email === "") {
            setErrorMsg(I("* You cannot leave the Email field empty."));
            return;
        } else if (!adminHelper.validateEmail(email)) {
            setErrorMsg(I("* Invalid email address."));
            return;
        }
        
        AdminAction.saveAreaExtFwdAddr(props.areaId, {
            name: name,
            email: email
        })
        .then(() => {
            AdminAction.getAreaExtFwdAddr(props.areaId);
        });
    };

    const handleNameChange = (v) => {
        setName(v);
        setErrorMsg("");
    };

    const handleEmailChange = (v) => {
        setEmail(v);
        setErrorMsg("");
    };

    const RemoveButton = {
        action: webRoot + "areas/" + props.areaId + "/extfwdaddr/{id}",
        name: I("Remove"),
        className: "fa fa-remove"
    };
    
    const NameField = (
        <Textfield
            id="nameAdd"
            value={name}
            name={I("Name")}
            onChange={handleNameChange}
        />
    );
    
    const EmailField = (
        <Textfield
            id="emailAdd"
            value={email}
            name={I("email")}
            onChange={handleEmailChange}
        />
    );
    
    const RemoveField = {
        type: "orgEdit"
    };
    
    const column = [
        { header: I("Name"), key: "name", subHeaderAction: NameField },
        { header: I("Email"), key: "email", subHeaderAction: EmailField },
        { header: I("Action"), type: "actionCombineLink", data: RemoveButton, subHeaderAction: RemoveField, orgType: 'edit' }
    ];

    return (
        <div className="area-forward-external">
            <div className="row">
                <TableComponent
                    dataSource={addrList}
                    columns={column}
                    id={'AreaExtFwdAddr'}
                    itemDeleteAction={handleItemDeleteAction}
                    paginate={true}
                    pageSize={defaultPaginationSize}
                    enablePageSizeChange={false}
                    enableSubHeaders={true}
                    organisationV5={true}
                    areaEditV5={true}
                    itemAddAction={addAreaExtFwdAddr}
                />
            </div>
        </div>
    );
}

function AreaKeywords(props) {
    const [selectedId, setSelectedId] = useState(0);
    const [name, setName] = useState("");
    const [type, setType] = useState("Subject or text");
    const [content, setContent] = useState("");
    const [typeAuto, setTypeAuto] = useState("Subject or text");
    const [autoTags, setAutoTags] = useState("");
    const [contentAuto, setContentAuto] = useState("");
    const [keywordsList, setKeywordsList] = useState(
        AdminStore.getState().areaKeywordsList?.list || []
    );
    const [autoTagMap, setAutoTagMap] = useState(
        AdminStore.getState().autoTagsRulesMap || {}
    );
    const [currentTagVIP, setCurrentTagVIP] = useState(false);
    const [showColorPicker, setShowColorPicker] = useState(false);
    const [selectedTagVIPColor, setSelectedTagVIPColor] = useState("#d0021b");

    useEffect(() => {
        AdminAction.getAreaKeywords(props.areaId);
        AdminAction.getAreaAutoTagRules(props.areaId);
        AdminStore.listen(onFluxStoreChange);
        
        return () => {
            AdminStore.unlisten(onFluxStoreChange);
            sessionStorage.setItem('areaAutoTags', "");
        };
    }, [props.areaId]);

    const onFluxStoreChange = (state) => {
        if (state.areaKeywordsList != null) {
            setKeywordsList(state.areaKeywordsList.list);
            setName(state.areaKeywordsList.areaName);
        } else {
            setKeywordsList([]);
        }
        
        if (state.autoTagsRulesMap != null) {
            setAutoTagMap(state.autoTagsRulesMap);
        } else {
            setAutoTagMap({});
        }
    };

    const handleItemDeleteAction = (action) => {
        // delete row and also remove from area->routing rules array
        $.ajax(action, {
            type: "DELETE"
        }).done(() => {
            AdminAction.getAreaKeywords(props.areaId);
        });
    };

    const handleTagDeleteAction = (action) => {
        $.ajax(action, {
            type: "DELETE"
        }).done(() => {
            AdminAction.getAreaAutoTagRules(props.areaId);
        });
    };

    const cancelList = () => {
        location.href = window.location.protocol + "//" +
            window.location.hostname + pathPrefix + "admin#organisations";
    };

    const addAreaRoutingRule = () => {
        if (content.length === 0) {
            return;
        }
        AdminAction.saveAreaKeywords(props.areaId, {
            // NO need for selected Id we will always create new
            id: selectedId,
            type: type,
            content: content
        })
        .then(() => {
            setContent("");
            AdminAction.getAreaKeywords(props.areaId);
        });
    };

    const handleUpdateType = (v) => {
        setType(v);
    };

    const handleUpdateAutoType = (v) => {
        setTypeAuto(v);
    };

    const checkVIPTag = (tag) => {
        const autoTags = autoTagsMapToArray();
        if (autoTags && autoTags.length > 0) {
            for (let i = 0; i < autoTags.length; i++) {
                const item = autoTags[i];
                if (item.tagId === tag) {
                    if (item.isVIP) {
                        return true;
                    }
                    return false;
                }
            }
        }
        return false;
    };

    const getDefaultTagColor = (tag) => {
        const defaultTagColor = "#d0021b"; // default red
        const autoTags = autoTagsMapToArray();
        if (autoTags && autoTags.length > 0) {
            for (let i = 0; i < autoTags.length; i++) {
                const item = autoTags[i];
                if (item.tagId === tag) {
                    if (item.isVIP && item.tagColor !== "") {
                        return item.tagColor;
                    }
                    return defaultTagColor;
                }
            }
        }
        return defaultTagColor;
    };

    const handleUpdateAutoTags = (v) => {
        const isVIP = checkVIPTag(v);
        const defaultTagColor = getDefaultTagColor(v);
        setAutoTags(v);
        setCurrentTagVIP(isVIP);
        setSelectedTagVIPColor(defaultTagColor);
    };

    const toggleColorPicker = () => {
        setShowColorPicker(!showColorPicker);
    };

    const handleChangeFlagColor = (c) => {
        setSelectedTagVIPColor(c);
    };

    const addAutoTagRule = () => {
        const autoTag = JSON.parse(sessionStorage.getItem("areaAutoTags"));
        let autoTagId = "";
        
        if (contentAuto.length === 0) {
            return;
        }
        
        if (autoTag != null) {
            autoTag.forEach((item) => {
                if (item.tagId === autoTags) {
                    autoTagId = item.tagId;
                }
            });
        }
        
        if (autoTagId.length > 0) {
            let typeAutoValue = typeAuto;
            if (typeAutoValue.length === 0) {
                typeAutoValue = "Subject or text";
            }
            
            AdminAction.saveAreaAutoTagRules(props.areaId, {
                tagLevel: autoTagId,
                type: typeAutoValue,
                content: contentAuto,
                tagVIPColor: selectedTagVIPColor
            })
            .then(() => {
                setContentAuto("");
                setAutoTags("");
                AdminAction.getAreaAutoTagRules(props.areaId);
            });
        }
    };

    const parseAutoTags = (tagNames, tags, parentStr, parentId) => {
        for (let i = 0; i < tags.length; i++) {
            const tag = tags[i];
            let newTagId = '' + tag.id;
            
            if (parentId.length > 0) {
                newTagId = parentId + "," + tag.id;
            }
            
            if (tag.children != null) {
                parseAutoTags(tagNames, tag.children, parentStr + tag.value + "/", newTagId);
            } else {
                tagNames[newTagId] = { 
                    "name": (parentStr + tag.value), 
                    isVIP: tag.isVIP, 
                    tagColor: tag.tagColor 
                };
            }
        }
    };

    const autoTagsMapToArray = () => {
        let arr = [];
        let autoTags = [];
        let tagNames = {};
        
        if (typeof autoTagMap["areaTags"] !== 'undefined' &&
            autoTagMap["areaTags"][props.areaId] != null) {
            autoTags = autoTagMap["areaTags"][props.areaId]["normal_tags"];
            parseAutoTags(tagNames, autoTags, "", "");
        }
        
        for (let key in tagNames) {
            if (tagNames.hasOwnProperty(key)) {
                arr.push({ 
                    id: tagNames[key].name, 
                    tagId: key, 
                    value: tagNames[key].name, 
                    isVIP: tagNames[key].isVIP, 
                    tagColor: tagNames[key].tagColor 
                });
            }
        }
        
        return arr;
    };

    const handleContentAutoTextChange = (text) => {
        setContentAuto(text);
        $(".with-errors-content-auto").html("");
    };

    const handleContentAdd = (text) => {
        setContent(text);
        $(".with-errors-content").html("");
    };

    const typeItems = [
        { id: "Subject or text", type: "Subject or text" },
        { id: "Subject", type: "Subject" },
        { id: "From", type: "From" },
        { id: "To", type: "To" }
    ];
    
    const autoTagList = autoTagMap["list"];
    const autoTagsArray = autoTagsMapToArray();
    sessionStorage.setItem('areaAutoTags', JSON.stringify(autoTagsArray));
    
    const tagDropDownField = (
        <DropDown
            items={typeItems}
            fields={{ id: "id", name: "type" }}
            multiSelect={false}
            wantSelectAll={false}
            selectedItems={type}
            onChange={handleUpdateType}
        />
    );

    const tagTextField = (
        <Textfield
            id="contentAdd"
            value={content}
            name={I("Content")}
            onChange={handleContentAdd}
        />
    );

    const autoTagDropDownType = (
        <DropDown
            items={typeItems}
            fields={{ id: "id", name: "type" }}
            multiSelect={false}
            wantSelectAll={false}
            selectedItems={typeAuto}
            onChange={handleUpdateAutoType}
        />
    );

    const autoTagTextField = (
        <Textfield
            id="contentAdd"
            value={contentAuto}
            name={I("ContentAuto")}
            onChange={handleContentAutoTextChange}
        />
    );

    const autoTagColorField = currentTagVIP ? (
        <ColorPicker
            id="areaRouteColorPicker"
            onChangeColor={handleChangeFlagColor}
            selected={selectedTagVIPColor}
        />
    ) : <span />;

    const autoTagDropDownFieldTag = (
        <DropDown
            class="autotag-v5"
            items={autoTagsArray}
            fields={{ id: "tagId", name: "value" }}
            multiSelect={false}
            wantSelectAll={false}
            selectedItems={autoTags}
            onChange={handleUpdateAutoTags}
        />
    );

    const addButton = {
        type: "orgEdit"
    };

    const RemoveButton = {
        action: webRoot + "areas/" + props.areaId + "/keywords/{id}",
        name: I("Remove"),
        className: "fa fa-remove"
    };

    const RemoveAutoTagButton = {
        action: webRoot + "areas/" + props.areaId + "/autotagrules/{id}",
        name: I("Remove"),
        className: "fa fa-remove"
    };
    
    const column = [
        { header: I("Type"), key: "type", subHeaderAction: tagDropDownField },
        { header: I("Content"), key: "content", subHeaderAction: tagTextField },
        { header: I("Action"), type: "actionCombineLink", data: RemoveButton, subHeaderAction: addButton, orgType: 'edit' }
    ];
    
    const autotagColumn = [
        { header: I("Type"), key: "type", subHeaderAction: autoTagDropDownType },
        { header: I("Content"), key: "content", subHeaderAction: autoTagTextField },
        { header: I("Tag"), key: "tag", subHeaderAction: autoTagDropDownFieldTag },
        { header: I("Color"), key: "tagColor", type: "withColor", subHeaderAction: autoTagColorField },
        { header: "", type: "actionCombineLink", data: RemoveAutoTagButton, subHeaderAction: addButton, orgType: 'edit' }
    ];
    
    return (
        <div className="area-routing">
            <div className="row">
                <TableComponent
                    dataSource={keywordsList}
                    columns={column}
                    id={'areakeywordstable'}
                    itemDeleteAction={handleItemDeleteAction}
                    paginate={true}
                    pageSize={defaultPaginationSize}
                    enablePageSizeChange={false}
                    enableSubHeaders={true}
                    organisationV5={true}
                    areaEditV5={true}
                    itemAddAction={addAreaRoutingRule}
                />
            </div>
            {props.autotag && (
                <div className="autoTag-table">
                    <div className="row">
                        <div className="col-lg-12">
                            <h6 className="page-header">
                                {I('Automatic Tagging Rules (tag errands routed to this area)')}
                            </h6>
                        </div>
                    </div>
                    <div className="row">
                        <TableComponent
                            dataSource={autoTagList}
                            columns={autotagColumn}
                            id={'areaautokeywordstable'}
                            itemDeleteAction={handleTagDeleteAction}
                            paginate={true}
                            pageSize={defaultPaginationSize}
                            enablePageSizeChange={false}
                            enableSubHeaders={true}
                            organisationV5={true}
                            areaEditV5={true}
                            itemAddAction={addAutoTagRule}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

function AreaReplacement(props) {
    const [selectedId, setSelectedId] = useState(0);
    const [areaName, setAreaName] = useState("");
    const [action, setAction] = useState("Remove");
    const [removeType, setRemoveType] = useState("0");
    const [search, setSearch] = useState("");
    const [perform, setPerform] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [replacementList, setReplacementList] = useState(
        AdminStore.getState().areaReplacementList?.list || []
    );

    useEffect(() => {
        AdminAction.getAreaReplacement(props.areaId);
        AdminStore.listen(onFluxStoreChange);
        
        return () => {
            AdminStore.unlisten(onFluxStoreChange);
        };
    }, [props.areaId]);

    const removeTypeToString = (i) => {
        let retString = "" + i;
        switch (i) {
            case -1:
                retString = I("Remove matching string");
                break;
            case 0:
                retString = I("Remove same line");
                break;
            case 1:
                retString = I("Remove same line and one line below");
                break;
            case 2:
                retString = I("Remove same line and two lines below");
                break;
            case 3:
                retString = I("Remove same line and three lines below");
                break;
            case 4:
                retString = I("Remove same line and four lines below");
                break;
            case 5:
                retString = I("Remove same line and five lines below");
                break;
        }
        return retString;
    };

    const alterListActionString = (theList) => {
        let newList = [];
        if (theList) {
            for (let i = 0; i < theList.length; i++) {
                let newPerform = theList[i].perform;
                if (theList[i].action === "Replace") {
                    newPerform = I("Replace with {0}").replace('{0}', theList[i].perform);
                } else {
                    newPerform = removeTypeToString(theList[i].removeType);
                }
                let arrayItem = {
                    action: theList[i].action, 
                    id: theList[i].id,
                    perform: newPerform, 
                    search: theList[i].search
                };
                newList.push(arrayItem);
            }
        }
        return newList;
    };

    const onFluxStoreChange = (state) => {
        if (state.areaReplacementList != null) {
            const newList = alterListActionString(state.areaReplacementList.list);
            setReplacementList(newList);
            setAreaName(state.areaReplacementList.areaName);
            setAction("Remove");
            setRemoveType("0");
            setSearch("");
            setPerform("");
        } else {
            setReplacementList([]);
        }
    };

    const handleItemDeleteAction = (action) => {
        $.ajax(action, {
            type: "DELETE"
        }).done(() => {
            AdminAction.getAreaReplacement(props.areaId);
        });
    };

    const cancelList = () => {
        location.href = window.location.protocol + "//" +
            window.location.hostname + pathPrefix + "admin#organisations";
    };

    const addAreaReplacement = () => {
        if (search === "") {
            setErrorMsg(I("* You cannot leave the Search for field empty."));
            return;
        }
        
        if (action === "Replace" && perform === "") {
            setErrorMsg(I("* You cannot leave the Replace with field empty."));
            return;
        }
        
        AdminAction.saveAreaReplacement(props.areaId, {
            action: action,
            removeType: removeType,
            search: search,
            perform: perform
        })
        .then(() => {
            setSearch("");
            setPerform("");
            AdminAction.getAreaReplacement(props.areaId);
        });
    };

    const handleDropDown = (v) => {
        setAction(v);
    };

    const handleRemoveDropDown = (v) => {
        setRemoveType(v);
    };

    const handleSearchForChange = (text) => {
        setSearch(text);
        $(".with-errors-content").html("");
    };

    const handleReplaceWithChange = (text) => {
        setPerform(text);
        $(".with-errors-content").html("");
    };

    const typeItems = [
        { id: "Replace", type: "Replace" },
        { id: "Remove", type: "Remove" }
    ];
    
    const removeTypes = [
        { id: "-1", type: I("Remove matching string") },
        { id: "0", type: I("Remove same line") },
        { id: "1", type: I("Remove same line and one line below") },
        { id: "2", type: I("Remove same line and two lines below") },
        { id: "3", type: I("Remove same line and three lines below") },
        { id: "4", type: I("Remove same line and four lines below") },
        { id: "5", type: I("Remove same line and five lines below") }
    ];
    
    const isReplace = (action === "Replace");
    
    const RemoveButton = {
        action: webRoot + "areas/" + props.areaId + "/replacement/{id}",
        name: I("Remove"),
        className: "fa fa-remove"
    };
    
    const ActionField = (
        <DropDown
            items={typeItems}
            fields={{ id: "id", name: "type" }}
            multiSelect={false}
            wantSelectAll={false}
            selectedItems={action}
            onChange={handleDropDown}
        />
    );
    
    const SearchField = (
        <Textfield
            id="search"
            value={search}
            name={I("search")}
            onChange={handleSearchForChange}
        />
    );
    
    const PerformField = isReplace ? (
        <Textfield
            id="perform"
            value={perform}
            name={I("perform")}
            onChange={handleReplaceWithChange}
        />
    ) : (
        <DropDown
            items={removeTypes}
            fields={{ id: "id", name: "type" }}
            multiSelect={false}
            wantSelectAll={false}
            selectedItems={removeType}
            onChange={handleRemoveDropDown}
        />
    );
    
    const RemoveField = {
        type: "orgEdit"
    };
    
    const column = [
        { header: I("Actions"), key: "action", subHeaderAction: ActionField },
        { header: I("Search"), key: "search", subHeaderAction: SearchField },
        { header: I("Perform"), key: "perform", subHeaderAction: PerformField },
        { header: I("Action"), type: "actionCombineLink", data: RemoveButton, subHeaderAction: RemoveField, orgType: 'edit' }
    ];

    return (
        <div className="area-replacement">
            <div className="row">
                <TableComponent
                    dataSource={replacementList}
                    columns={column}
                    id={'AreaReplacement'}
                    itemDeleteAction={handleItemDeleteAction}
                    paginate={true}
                    pageSize={defaultPaginationSize}
                    enablePageSizeChange={false}
                    enableSubHeaders={true}
                    organisationV5={true}
                    areaEditV5={true}
                    itemAddAction={addAreaReplacement}
                />
            </div>
        </div>
    );
}

function SmppAccounts(props) {
    const [showEdit, setShowEdit] = useState(false);
    const [name, setName] = useState("");
    const [pageLoaded, setPageLoaded] = useState(false);
    const [smppAccountId, setSmppAccountId] = useState(0);
    const [areaSmppAccountSrc, setAreaSmppAccountSrc] = useState({});
    const [smppAreaAccountsList, setSmppAreaAccountsList] = useState(
        AdminStore.getState().smppAreaAccountsList?.smppAccounts || []
    );

    useEffect(() => {
        AdminStore.listen(onFluxStoreChange);
        AdminAction.getAreaSmppAccounts(props.areaId);
        
        return () => {
            AdminStore.unlisten(onFluxStoreChange);
        };
    }, [props.areaId]);

    const onFluxStoreChange = (state) => {
        if (state.smppAreaAccountsList != null) {
            setSmppAreaAccountsList(state.smppAreaAccountsList.list);
            setName(state.smppAreaAccountsList.areaName);
        } else {
            setSmppAreaAccountsList([]);
        }
        
        if (typeof state.smppAreaAccountSrc !== "undefined") {
            setAreaSmppAccountSrc(state.smppAreaAccountSrc);
        } else {
            setAreaSmppAccountSrc({
                name: "", 
                msisdn: "", 
                enabled: true,
                phonePrefix: "", 
                msisdnMask: ""
            });
        }
    };

    const createNewTemplate = () => {
        loadAreaAccountEditComponent(0);
    };

    const loadAreaAccountEditComponent = (id) => {
        setShowEdit(true);
        setSmppAccountId(id);
        setAreaSmppAccountSrc({});
        AdminAction.getAreaSmppAccountById(props.areaId, id);
    };

    const renderAreaSmppAccountForm = () => {
        if (!showEdit) {
            return null;
        }
        
        const modal = document.getElementById("smpp-edit-modal");
        const innerModal = document.getElementById("areaSmppAccountEditForm");
        const modalWidth = document.querySelector('#area-edit-v5').clientWidth;

        modal.style.display = "block";
        innerModal.style.maxWidth = "" + modalWidth + "px";
        
        const pageTitle = smppAccountId !== 0 ? I("Edit smpp account") : I("Create smpp account");
        
        return (
            <AreaSmppAccountForm 
                id={smppAccountId} 
                areaId={props.areaId}
                src={areaSmppAccountSrc}
                onNameChange={onNameChange}
                onMsisdnChange={onMsisdnChange}
                onPhonePrefixChange={onPhonePrefixChange}
                onMsisdnMaskChange={onMsisdnMaskChange}
                onEnabledChange={onEnabledChange}
                onSave={handleEditSave}
                pageTitle={pageTitle} 
                onHide={handleCloseEdit} 
            />
        );
    };

    const rowClickHandle = (id) => {
        loadAreaAccountEditComponent(id);
    };

    const handleItemDeleteAction = (action) => {
        $.ajax(action, {
            type: "DELETE"
        }).done(() => {
            AdminAction.getAreaSmppAccounts(props.areaId);
        });
    };

    const cancelList = () => {
        setShowEdit(false);
        location.href = window.location.protocol + "//" +
            window.location.hostname + pathPrefix + "admin#organisations";
    };

    const handleCloseEdit = () => {
        const modal = document.getElementById("smpp-edit-modal");
        modal.style.display = "none";
        setShowEdit(false);
    };

    const handleEditSave = () => {
        if ((typeof areaSmppAccountSrc.name === "undefined") ||
            (areaSmppAccountSrc.name === "")) {
            $(".with-errors-name").html(I("* You cannot leave the field empty."));
            return;
        }
        
        if ((typeof areaSmppAccountSrc.msisdn === "undefined") ||
            (areaSmppAccountSrc.msisdn === "")) {
            $(".with-errors-msisdn").html(I("* You cannot leave the field empty."));
            return;
        }
        
        let phonePrefix = areaSmppAccountSrc.phonePrefix;
        if (typeof phonePrefix === "undefined") {
            phonePrefix = "";
        }
        
        let msisdnMask = areaSmppAccountSrc.msisdnMask;
        if (typeof msisdnMask === "undefined") {
            msisdnMask = "";
        }
        
        AdminAction.saveAreaSmppAccount(props.areaId, {
            id: parseInt(smppAccountId),
            name: areaSmppAccountSrc.name.trim(),
            msisdn: areaSmppAccountSrc.msisdn.trim(),
            phonePrefix: phonePrefix.trim(),
            msisdnMask: msisdnMask.trim(),
            enabled: areaSmppAccountSrc.enabled
        })
        .then(() => {
            handleCloseEdit();
            AdminAction.getAreaSmppAccounts(props.areaId);
        });
    };

    const onNameChange = (v) => {
        setAreaSmppAccountSrc(prev => update(prev, {
            $merge: { name: v }
        }));
    };

    const onMsisdnChange = (v) => {
        setAreaSmppAccountSrc(prev => update(prev, {
            $merge: { msisdn: v }
        }));
    };

    const onPhonePrefixChange = (v) => {
        setAreaSmppAccountSrc(prev => update(prev, {
            $merge: { phonePrefix: v }
        }));
    };

    const onMsisdnMaskChange = (v) => {
        setAreaSmppAccountSrc(prev => update(prev, {
            $merge: { msisdnMask: v }
        }));
    };

    const onEnabledChange = (v) => {
        setAreaSmppAccountSrc(prev => update(prev, {
            $merge: { enabled: v }
        }));
    };

    const RemoveButton = {
        action: webRoot + "areas/" + props.areaId + "/smppaccounts/{id}",
        name: I("Remove"),
        className: "fa fa-remove"
    };
    
    const column = [
        { header: I("Name"), key: "name" },
        { header: I("Action"), type: "actionCombineLink", data: RemoveButton, orgType: "area-smpp" }
    ];
    
    const activeButton = showEdit ? "active" : "";
    
    return (
        <div className="area-sms">
            <div className="row">
                <div className="col-lg-12" style={{ textAlign: "right" }}>
                    <TableIconicButton
                        type='button'
                        className={'btn bg-transparent btn-round ' + activeButton}
                        iconClass='icon-add'
                        title={I('Create new')}
                        onClick={() => createNewTemplate()}
                    />
                </div>
            </div>
            <div className="row">
                <TableComponent
                    dataSource={smppAreaAccountsList}
                    columns={column}
                    id={'smppAreaAccountsTable'}
                    itemDeleteAction={handleItemDeleteAction}
                    paginate={true}
                    pageSize={defaultPaginationSize}
                    enablePageSizeChange={false}
                    highlightRow={rowClickHandle}
                    organisationV5={true}
                    onHandleEnableChange={onEnabledChange}
                    onEditActionRow={rowClickHandle}
                />
            </div>
            <div id="smpp-edit-modal">
                <div className="row">
                    <div className="col-lg-12" id="areaSmppAccountEditForm">
                        {renderAreaSmppAccountForm()}
                    </div>
                </div>
            </div>
        </div>
    );
}

function AreaSmppAccountForm(props) {
    const handleNameChange = (v) => {
        props.onNameChange(v);
        $(".with-errors-name").html("");
    };

    const handleMsisdnChange = (v) => {
        props.onMsisdnChange(v);
        $(".with-errors-msisdn").html("");
    };

    const handlePhonePrefixChange = (v) => {
        props.onPhonePrefixChange(v);
    };

    const handleMsisdnMaskChange = (v) => {
        props.onMsisdnMaskChange(v);
    };

    const handleEnabledChange = () => {
        props.onEnabledChange(!props.src.enabled);
    };

    const tempVar = props.src;
    if (Object.keys(tempVar).length <= 0) {
        return <span>{I("Loading SMPP Account to add/edit")}</span>;
    }
    
    return (
        <div className="panel panel-default">
            <div className="panel-body">
                <div className="row">
                    <div className="col-lg-6">
                        <label className="col-lg-12 control-label" htmlFor="basic">
                            <span className="mandatory">* </span>{I('SMPP Account Name')}
                        </label>
                        <div className="col-lg-12">
                            <Textfield
                                id="name"
                                setDefaultText={props.src.name}
                                name={I("Name")}
                                onChange={handleNameChange}
                            />
                            <div style={{ color: 'red' }} className="help-block with-errors-name"></div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <label className="col-lg-12 control-label" htmlFor="basic">{I('Enabled')}</label>
                        <div className="col-lg-12">
                            <SwitchCheckbox
                                active={props.src.enabled}
                                buttonClassName={""}
                                id={"orgActiveSwitch"}
                                name={"orgActive"}
                                type="checkbox"
                                onClick={handleEnabledChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <label className="col-lg-12 control-label" htmlFor="basic">
                            <span className="mandatory">* </span>{I('MSISDN or Name')}
                        </label>
                        <div className="col-lg-12">
                            <Textfield
                                id="msisdn"
                                setDefaultText={props.src.msisdn}
                                name={I("MSISDN")}
                                onChange={handleMsisdnChange}
                            />
                            <div style={{ color: 'red' }} className="help-block with-errors-msisdn"></div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <label className="col-lg-12 control-label" htmlFor="basic">{I('Phone Prefix')}</label>
                        <div className="col-lg-12">
                            <Textfield
                                id="phonePrefix"
                                setDefaultText={props.src.phonePrefix}
                                name={I("Phone Prefix")}
                                onChange={handlePhonePrefixChange}
                            />
                            <div style={{ color: 'red' }} className="help-block with-errors-system-type"></div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <label className="col-lg-12 control-label" htmlFor="basic">{I('MSISDN Mask')}</label>
                        <div className="col-lg-12">
                            <Textfield
                                id="msisdnMask"
                                setDefaultText={props.src.msisdnMask}
                                name={I("MSISDN Mask")}
                                onChange={handleMsisdnMaskChange}
                            />
                            <div style={{ color: 'red' }} className="help-block with-errors-system-type"></div>
                        </div>
                    </div>
                </div>
                <div className="form-group editPageActionButton">
                    <div className="row">
                        <div className="col-lg-12 textAlignRight">
                            <CancelButton onClick={props.onHide} />
                            <SaveButton
                                key="btn-save-admin"
                                onClick={props.onSave}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default class AreaTableEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            type: 1
        };
    }

    handleRenderSettings = (type, id) => {
        switch (type) {
            case AREAROUTING:
                return <AreaKeywords areaId={id} autotag={features?.["routing.autotag"]} />;
            case AREAREPLACEMENT:
                return <AreaReplacement areaId={id} />;
            case AREAAUTOFORWARD:
                return <AreaAutoFwdExtAddr areaId={id} />;
            case AREASMS:
                return <SmppAccounts areaId={id} />;
            case AREAFORWARDEXTERNAL:
                return <AreaExtFwdAddr areaId={id} />;
            default:
                return null;
        }
    };

    render() {
        const { type, id, cancelToOrg } = this.props;
        const renderSetting = this.handleRenderSettings(type, id);
        
        return (
            <div className="col-lg-12 area-edit-settings">
                <div className="form-group-org">
                    <div className="col-lg-12">
                        {renderSetting}
                    </div>
                </div>
                <div className="form-group editPageActionButton">
                    <div className="row">
                        <div className="col-lg-12 textAlignRight">
                            <CancelButton onClick={cancelToOrg} />
                            {/* <SaveButton
                                key="btn-save-admin"
                                onClick={this.props.saveOrg}
                            /> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
